import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc, updateAAGroup } from "../../../apiclients/streamsapi_bridge";
import TelephoneNumbers from "../../TelephoneNumbers";
import AudioPlayer from "../../mediaplayers/AudioPlayer";
import { MDBAutocomplete } from "mdb-react-ui-kit";
import { useFormContext } from "react-hook-form";
import { customSearch } from "../../CustomSearchUtil/CustomSearch";
import RouteOperator from "../editUtils/RouteOperator";
//import { isEmpty, isEmail } from "../../../helpers/validation_helper.js";

const AAGeneralSettings = ({
  dids,
  aaextension,
  aagcode,
  groupname,
  setSuccessMessage,
  greetingsInfo,
  isActive,
  operatorValue,
  setIsloading,
  selectedItem,
  setSelectedItem,
}) => {
  const {
    register,
    setValue,
    formState: { errors },
    getValues,
    setError,
    watch,
    clearErrors,
  } = useFormContext();
  const { t, i18n } = useTranslation();
  const [AddNumbers, setAddNumbers] = useState(false);
  const toggleShow12 = () => setAddNumbers(!AddNumbers);
  const [autogcode, setAutoGcode] = useState("");
  // const [error, setError] = useState({});
  const [autoext, setAutoext] = useState(false);
  const [checkAvailbility, setCheckAvailbility] = useState("");
  const [checkAvailbilityTxt, setCheckAvailbilityTxt] = useState("");
  const [extCheckFlag, setextCheckFlag] = useState(0);
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [grpaddednumbers, setGrpAddedNumbers] = useState([]);
  const [finaladdlist, setFinalAddList] = useState([]);
  const [finalremovedlist, setFinalRemovedList] = useState([]);
  const [phoneNum, setPhoneNum] = useState([]);
  const [billingGroupsList, setBillingGroupsList] = useState([]);
  const [gname, setGName] = useState("");
  const [selectedPHnums, setSelectedPHnums] = useState([]);
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [billingList, setBillingList] = useState([]);
  const navigate = useNavigate();
  const { pre_announce, moh } = greetingsInfo ?? {};

  const [extensionFlag, setExtensionFlag] = useState(true);
  const [defaultExtension, setDefaultExtension] = useState(0);
  const [showMoh, setShowMoh] = useState(false);
  const [greetingMode, setGreetingMode] = useState(0);
  const [audioData, setAudioData] = useState("");
  const [directorySearch, setdirectorySearch] = useState([]);
  const [diretoryList, setdiretoryList] = useState([]);
  const [humanOperators, sethumanOperators] = useState([]);
  const [humanOperatorsDisplay, sethumanOperatorsDisplay] = useState([]);
  const [routingValue, setroutingValue] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const dropdownRef = useRef(null);
  const [search, setSearch] = useState("");
  const [includeList, setincludeList] = useState([]);
  const [excludeList, setexcludeList] = useState([]);
  const [humanOperatorList, sethumanOperatorList] = useState({});
  const [isLoading, setisLoading] = useState(false);


  const fieldNames = {hopType: "operator.type",
  value: "operator.value",
  }

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowOptions(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const include = "Include List";
  const exclude = "Exclude List";
  const groupedData = {
    [include]: includeList,
    [exclude]: excludeList,
  };
  const filteredGroups = Object.entries(groupedData)
    .map(([group, items]) => {
           const filteredItems = customSearch(items, search, ["name"]);
      return { group, items: filteredItems };
    })
    .filter((group) => group.items.length > 0);

  useEffect(() => {
    if (moh?.greeting_id) {
      setShowMoh(true);
    } else {
      setShowMoh(false);
      setAudioData("");
    }
  }, [moh]);


  useEffect(() => {
    if (extensionFlag && getValues("extension") != 0) {
      setDefaultExtension(getValues("extension"));
      setExtensionFlag(false);
    }
  }, [extensionFlag, getValues("extension")]);

  useEffect(() => {
    if (dids.length > 0) {
      setSelectedPHnums(dids);
      setdbPhoneNumbers(dids);
    }
  }, [dids]);

  useEffect(() => {
    if (aagcode && isActive) {
      setAutoGcode(aagcode);
      setGName(groupname);
      getDirectoryList();
    }
  }, [aagcode, isActive]);

  async function checkAvailability(e) {
    e.preventDefault();
    e.stopPropagation();
    setextCheckFlag(1);
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids", "all_locations", "billinggroups", "dir_search"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    // alert(JSON.stringify(basicInfo.misc.free_dids))
    setSourceNumber(basicInfo.misc.free_dids);
    setLocationList(basicInfo.misc.all_locations);
    setBillingList(basicInfo.misc.billinggroups);
    setdirectorySearch(basicInfo.misc.dir_search);
  }

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("adddids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removedids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function getDirectoryList() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["dir_lists"],
      code: parseInt(aagcode),
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(
      "response data is directory:::::::::: " + JSON.stringify(basicInfo)
    );
    // alert(JSON.stringify(basicInfo.misc.free_dids))
    setdiretoryList(basicInfo.misc.dir_lists);

    setincludeList(
      basicInfo.misc.dir_lists
        .filter((item) => item.type === 0)
        .map((item) => ({ name: item.name, id: item.dir_id }))
    );
    setexcludeList(
      basicInfo.misc.dir_lists
        .filter((item) => item.type === 1)
        .map((item) => ({ name: item.name, id: item.dir_id }))
    );
    if (watch("directorylistid") && watch("directorylistid") !== "") {
      const userObj = basicInfo.misc.dir_lists.find(
        (item) => parseInt(item.dir_id) === parseInt(watch("directorylistid"))
      );
      if (userObj) {
        setSelectedItem({ name: userObj.name, id: userObj.dir_id });
      }
    }
  }

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 25,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: aagcode,
      [fieldName]: updatePHNum,
    };

    console.log(JSON.stringify(update));
    //alert(JSON.stringify(update));
    let saverep = await updateAAGroup(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    //alert("response JSON ::: of update number ::::: " + JSON.stringify(saverepeMsg));

    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "adddids") {
        setSelectedPHnums((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} added successfully.`
        ); // success pop up message.
        //setHgUpdated(true);
      } else {
        const updateAddPHNum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        ); // success pop up message.
        //setHgUpdated(true);
      }
    } else {
      if (fieldName === "removedids") {
        const modifynum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums([...modifynum, ...updatePHNum]);
        setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
    }
    setIsloading(false);
  }

  useEffect(() => {
    if (operatorValue && Object.entries(operatorValue).length > 0) {
      const hopVal = `${operatorValue.title}${
        operatorValue.extension ? " : " + operatorValue.extension : ""
      }${
        operatorValue.type && operatorValue.type === 1
          ? " : Hunt Group"
          : " : User"
      }`;

      setroutingValue(hopVal);
    }
  }, [operatorValue]);

  // useEffect(() => {
  //   getHumanOperatorMisc();
  // }, []);

  // async function getHumanOperatorMisc() {
  //   const response = await getMisc(
  //     JSON.parse(sessionStorage.getItem("admin_session")).siteid,
  //     { misc: ["hopmisc"] }
  //   );
  //   if (!response.json) {
  //     const message = `An error has occured: ${response.statusText}`;
  //     return;
  //   }
  //   const tdata = await response.json();
  //   if (!tdata) {
  //     window.alert(`info with id  not found`);
  //   }
  //   console.log("tdata ::::::::::::::::::::::::::::: " + JSON.stringify(tdata));
  //   let users = tdata?.misc?.hopmisc?.user ?? [];
  //   let hggroup = tdata?.misc?.hopmisc?.hg ?? [];
  //   let acdgroup = tdata?.misc?.hopmisc?.acd ?? [];

  //    sethumanOperatorList({
  //     user: users,
  //     group: hggroup,
  //     acdgroup: acdgroup,
  //   });
  // }

  const onAdvancedSearch = (value) => {
    const lowercasedValue = value.toLowerCase();
    if (lowercasedValue.trim() !== "") {
      const filteredData =
      customSearch(humanOperators, lowercasedValue, ['title', 'extensions', 'category'] )
      // humanOperators.filter((item) => {
      //   const lowercasedTitle = item.title.toLowerCase();
      //   const isTitleMatch = lowercasedTitle.includes(lowercasedValue);
      //   const isExtensionsMatch =
      //     item.extensions && item.extensions.toString().includes(value);
      //   const isCategoryMatch =
      //     item.category && item.category.toLowerCase().includes(value);
      //   return isTitleMatch || isExtensionsMatch || isCategoryMatch;
      // });

      sethumanOperatorsDisplay(filteredData);
    } else {
      sethumanOperatorsDisplay([]);
    }
  };

  function handleSelect(e, result) {
    e?.preventDefault();
    // console.log("value :::::::::::::: " + JSON.stringify(result));
    if (result && result.indexOf(":") !== -1) {
      const resultObj = result && result.split(":");
      const valueObj = humanOperatorsDisplay.find(
        (item) => parseInt(item.extensions) === parseInt(resultObj[1].trim())
      );
      if (valueObj && Object.entries(valueObj).length > 0) {
        const operatorObj = {
          type: valueObj.operator_type,
          value:
            valueObj.operator_type === 1
              ? valueObj.code + ""
              : valueObj.agentid + "",
        };

        console.log(
          "operatorObj ::::::::::::::: " + JSON.stringify(operatorObj)
        );

        setValue("operator", operatorObj, { shouldDirty: true });
      }
    }
  }
  function handleChange(e, result) {
    e?.preventDefault();
    console.log("value :::::::::::::: " + JSON.stringify(result));
    const operatorObj = {
      type: result.operator_type,
      value:
        result.operator_type === 1 ? result.code + "" : result.agentid + "",
    };

    console.log("operatorObj ::::::::::::::: " + JSON.stringify(operatorObj));

    setValue("operator", operatorObj, { shouldDirty: true });
  }

  const handleSelectItem = (item) => {
    setSelectedItem(item);
    setShowOptions(false);
    setSearch("");
    // Update form value with the selected item's ID
    setValue("directorylistid", item.id, { shouldDirty: true });
  };

  console.log("dirlectory list value :::::: " + watch("directorylistid"));

  return (
    <>
      <div className="card-header p-2">
        <h5 className="mb-0">
          <div className="general-settings p-0 m-0" id="general">
            {t("general")}
          </div>
        </h5>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("name")}</div>

        <div className="form-outline w-30 ">
          <input
            maxLength={18}
            className="form-control"
            type="text"
            {...register("name", { required: "Name is required" })}
          />
          {errors.name && <p className="text-danger">{errors.name.message}</p>}
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("extension")}</div>
        <div className="w-30">
          <input
            className="w-100"
            type="text"
            maxLength={5}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            {...register("extension", {
              setValueAs: (value) => Number(value),
              required: "Extension is required",
              minLength: {
                value: 3,
                message: "Extension must be at least 3 characters",
              },
              maxLength: {
                value: 5,
                message: "Extension must not exceed 5 characters",
              },
            })}
            onChange={(e) => {
              if (e.target.value !== "") {
                if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                  if (parseInt(defaultExtension) === parseInt(e.target.value)) {
                    clearErrors("extension");
                  } else {
                    checkAvailability(e);
                  }
                } else {
                  setCheckAvailbility(false);
                  clearErrors("extension");
                }
                setValue("extension", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              } else {
                setValue("extension", "", {
                  shouldDirty: true,
                });
                clearErrors("extension");
                setCheckAvailbility(false);
              }
            }}
          />
          {errors.extension && (
            <>
              {!checkAvailbility && (
                <>
                  <p className="text-danger">{errors.extension.message}</p>
                </>
              )}

              {checkAvailbility && (
                <p style={{ color: "Green" }} className="clr-red">
                  {errors.extension.message}
                </p>
              )}
            </>
          )}
        </div>
      </div>

      <TelephoneNumbers
        savedPhoneNumbers={selectedPHnums}
        setSavedPhoneNumbers={setSelectedPHnums}
        setSuccessMessage={setSuccessMessage}
        uniqueid={aagcode}
        setUpdatePHNum={setUpdatePHNum}
        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
        sourceNumber={sourceNumber}
        setDeleteNumberFlag={setDeleteNumberFlag}
        dbPhoneNumbers={dbPhoneNumbers}
      />

      <div className="add-numbermain">
        <div className="tel-numbers">{t("location")}</div>
        <div className="w-30">
          <select
            className="form-control form-select"
            name="San Jose"
            value={parseInt(watch("loc_id"))}
            onChange={(e) =>
              setValue("loc_id", parseInt(e.target.value), {
                shouldDirty: true,
              })
            }
            // {...register("loc_id", { setValueAs: (value) => Number(value) })}
          >
            {locationList &&
              locationList.map((loc) => (
                <option value={loc.loc_id}>{loc.loc_name}</option>
              ))}
          </select>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("billing_Group")}</div>
        <div className="form w-30">
          <select
            className="form-control form-select  selectname"
            name="Default"
            value={parseInt(watch("billing_grp"))}
            onChange={(e) =>
              setValue("billing_grp", parseInt(e.target.value), {
                shouldDirty: true,
              })
            }
            // {...register("billing_grp", {
            //   setValueAs: (value) => Number(value),
            // })}
          >
            {billingList ? (
              billingList.map((billgrp) => (
                <option key={billgrp.groupid} value={billgrp.groupid}>
                  {billgrp.groupname}
                </option>
              ))
            ) : (
              <option value="">Loading...</option>
            )}
          </select>
        </div>
      </div>

      {/* <div class="add-numbermain">
        <div class="tel-numbers">Operator</div>
        <div className="w-30">
         
          <RouteOperator
            operatorsList={humanOperatorList}
            operatorValue={operatorValue}
            fieldNames = {fieldNames}
            aaflag = {true}
          />
        </div>
      </div> */}

      <div className="add-numbermain">
        <div>
          <div className="tel-numbers fw-500">{t("autoAttendantGreeting")}</div>
          <span className="phrecording">{t("autoAttendantGreetingtxt1")}</span>
        </div>
        {aagcode && aagcode !== "" && (
          <AudioPlayer
            uniqueId={aagcode}
            greetingType={pre_announce?.greeting_type ?? 4}
            greetingId={pre_announce?.greeting_id ?? 0}
            fileName={pre_announce?.filename ?? ""}
            title={t("autoAttendantGreeting")}
            greetingMode={pre_announce?.filename ?? "" !== "" ? 1 : 2}
            greetingTitle = {pre_announce?.title ?? ""}
            greetingObject = {pre_announce ?? null}
          />
        )}
      </div>

      {/* <div className="add-numbermain">
        <div className="tel-numbers">{t("directoryList")}</div>
        <div className="form w-30">
          <select
            className="form-control form-select selectname"
            name="All Users"
            value={parseInt(watch("directorylistid"))}
            onChange={(e) =>
              setValue("directorylistid", parseInt(e.target.value), {
                shouldDirty: true,
              })
            }
          >
            {diretoryList &&
              diretoryList.length > 0 &&
              diretoryList.map((diretory) => (
                <option value={diretory.dir_id}>{diretory.name}</option>
              ))}
          </select>
        </div>
      </div> */}
      <div className="add-numbermain ">
        <div class="tel-numbers w-60">
          Directory List
          <br />
          <span class="phrecording text-secondaryd-inline-block">
            By default, all users are included. You can select an exclude list
            to remove specific users from the default list, or select an include
            list to limit access to only the users in that list.
          </span>
        </div>
        <div className="w-30">
          <div className="select-wrapper-custom w-100" ref={dropdownRef}>
            <div
              className="form-select"
              onClick={() => setShowOptions(!showOptions)}
            >
              {selectedItem ? selectedItem.name : "Select a directory"}
            </div>
            {showOptions && (
              <div className="Luna-dropdown">
                <input
                  type="text"
                  className="search-input"
                  autoFocus
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <div className="options">
                  {filteredGroups.map(({ group, items }) => (
                    <div key={group}>
                      <div className="option-group">{group}</div>
                      <div className="option-items">
                        {items.map((item) => (
                          <div
                            key={item.id}
                            className={`option-item ${
                              selectedItem?.id === item.id ? "selected" : ""
                            }`}
                            onClick={() => handleSelectItem(item)}
                          >
                            {item.name}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                  {filteredGroups.length === 0 && (
                    <div className="no-results">No results found</div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("directorySearch")}</div>
        <div className="form w-30">
          <select
            className="form-control form-select selectname"
            name="All Users"
            value={parseInt(watch("dirsearchtype"))}
            onChange={(e) =>
              setValue("dirsearchtype", parseInt(e.target.value), {
                shouldDirty: true,
              })
            }
          >
            {directorySearch &&
              directorySearch.length > 0 &&
              directorySearch.map((item, index) => (
                <option key={index} value={parseInt(Object.values(item)[0])}>
                  {Object.keys(item)[0]}
                </option>
              ))}
          </select>
        </div>
      </div>

      <div className="add-numbermain-small p-2">
        {/* <div>
          <div className="add-numbermain">
            <span className="fw-500">{t("autoAttendantGreeting")}</span>
            <div>
              <label className="switch">
                <input className="form-control" type="checkbox" />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
          <span className="phrecording">{t("autoAttendantGreetingtxt")}</span>
        </div> */}

        <div className="add-numbermain">
          <div className="tel-numbers">
            <b>{t("autoAttendantMohGreeting")}</b>
            <br />
            <span className="phrecording">{t("autoAttendantGreetingtxt")}</span>
          </div>
          <div className="d-flex">
            <div className="phoneselect">
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    checked={showMoh}
                    onChange={(e) => {
                      setShowMoh(!showMoh);
                      if (
                        (moh?.greeting_id && !showMoh == false) ||
                        ((greetingMode == 1 || greetingMode == 2) &&
                          !showMoh == false)
                      ) {
                        setValue("enable_moh", false, {
                          shouldDirty: true,
                        });
                      } else {
                        setValue("enable_moh", true, {
                          shouldDirty: true,
                        });
                      }
                    }}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        {showMoh && (
          <div className="phoneselect width-100">
            {aagcode && aagcode !== "" && (
              <AudioPlayer
                uniqueId={aagcode}
                greetingType={moh?.greeting_type ?? 3}
                greetingId={moh?.greeting_id ?? 0}
                fileName={moh?.filename ?? ""}
                title={t("autoAttendantMohGreetingTitle")}
                greetingMode={moh?.filename ?? "" !== "" ? 1 : 2}
                setGreetingMode={setGreetingMode}
                greetingTitle = {moh?.title ?? ""}
                audioData={audioData}
                setAudioData={setAudioData}
                greetingObject = {moh ?? null}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default AAGeneralSettings;
